export function formatDate(
  isoDate: string,
  format:
    | "mmddyy"
    | "mmddyyyy"
    | "ddmmyy"
    | "ddmmyyyy"
    | "yymmdd"
    | "yyyymmdd" = "mmddyy", // Default format to mmddyy
  delimiter: string = "/"
): string {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = String(date.getFullYear()).slice(-2); // Last two digits of the year
  const fullYear = date.getFullYear(); // Full 4-digit year

  const formatMapping: { [key: string]: string } = {
    mmddyy: `${month}${delimiter}${day}${delimiter}${year}`,
    mmddyyyy: `${month}${delimiter}${day}${delimiter}${fullYear}`,
    ddmmyy: `${day}${delimiter}${month}${delimiter}${year}`,
    ddmmyyyy: `${day}${delimiter}${month}${delimiter}${fullYear}`,
    yymmdd: `${year}${delimiter}${month}${delimiter}${day}`,
    yyyymmdd: `${fullYear}${delimiter}${month}${delimiter}${day}`,
  };

  // Return the formatted date based on the selected format
  if (formatMapping[format]) {
    return formatMapping[format];
  }

  throw new Error(
    `Invalid format: ${format}. Valid formats are "mmddyy", "mmddyyyy", "ddmmyy", "ddmmyyyy", "yymmdd", "yyyymmdd".`
  );
}

export const getFileNameTimeStamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const date = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${date}_${hours}-${minutes}-${seconds}`;
};
